import React, { useState, useEffect } from "react";
import { GatsbyImage, getImage, StaticImage } from "gatsby-plugin-image";
import Slider from "react-slick";
import '../../sass/components/flexibleModules/_components.customerBusinessGridSection.scss';
import "../../sass/slick/slick.min.scss";
import "../../sass/slick/slick-theme.min.scss";

const CustomerBusinessGridSection = ({ data }) => {
    const [isRendered, setIsRendered] = useState(false);

    let settings = {
        dots: false,
        infinite: true,
        autoplay: true,
        cssEase: 'linear',
        arrows: false,
        speed: 3000,
        slidesToShow: 6,
        slidesToScroll: 1,
        draggable: true,
        centerMode: false,
        swipeToSlide: true,
        touchThreshold: 250,
        responsive: [
            {
                breakpoint: 1100,
                settings: {
                    slidesToShow: 5,
                }
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 2,
                }
            }
        ]
    };

    let settingsTwo = {
        dots: false,
        arrows: true,
        infinite: true,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 1,
        draggable: false,
        centerMode: false,
        swipeToSlide: true,
        centerPadding: '60px 0 0',
        touchThreshold: 250,
        responsive: [
            {
                breakpoint: 980,
                settings: {
                    slidesToShow: 2,
                    centerPadding: '40px',
                }
            },
            {
                breakpoint: 620,
                settings: {
                    slidesToShow: 1,
                    centerMode: false,
                    centerPadding: '0',
                }
            }
        ]
    };

    useEffect(() => {
        setIsRendered(true);
    }, []);

    return (
        <div className="cp-customerBusinessGrid" style={{ backgroundColor: `${data.backgroundColor}` }}>
            <div className="cp-customerBusinessGrid__inner" style={{ maxWidth: `${data.maxWidth ? (data.maxWidth / 16 + "rem") : ""}`, margin: "0 auto" }}>
                {data.customerBusinessGridSectionTitle &&
                    <h2 dangerouslySetInnerHTML={{ __html: data.customerBusinessGridSectionTitle }} />
                }
                {data.customerBusinessGridSectionTeaser &&
                    <p dangerouslySetInnerHTML={{ __html: data.customerBusinessGridSectionTeaser }} />
                }
                {data.customerBusinessGridSectionLogosRepeatePosition === 'yes' &&
                    <div className="cp-customerBusinessGrid__customerLogos l--flex l--bottomMargin">
                        {data.customerBusinessGridSectionLogosRepeate &&
                            <>
                                {data.customerBusinessGridSectionLogosRepeate.map((logoRepeater, index) => (
                                    <React.Fragment key={index}>
                                        {logoRepeater.logo &&
                                            <GatsbyImage image={getImage(logoRepeater.logo.gatsbyImage)} alt={logoRepeater.logo.altText} />
                                        }
                                    </React.Fragment>
                                ))}
                            </>
                        }
                    </div>
                }
                <div className={`cp-customerBusinessGrid__customers ${data.customerBusinessGridSectionCustomers.length > 3 ? "l-noflex" : "l--flex"}`}>
                    {data.customerBusinessGridSectionCustomers &&
                        <>
                            {data.customerBusinessGridSectionCustomers.length > 3 ?
                                <Slider {...settingsTwo}>
                                    {data.customerBusinessGridSectionCustomers.map((businessCustomers, index) => (
                                        <>
                                            {businessCustomers.link &&
                                                <a href={businessCustomers.link.url} target={businessCustomers.link.target} className={`cp-customerBusinessGrid__customers-section l--sliderSection l--${businessCustomers.customerSectionBackgroundColor ? businessCustomers.customerSectionBackgroundColor.substring(1) : ""}`} key={index} style={{ backgroundColor: `${businessCustomers.customerSectionBackgroundColor ? businessCustomers.customerSectionBackgroundColor : "#91D8FF"}` }}>
                                                    <div className="l-customerlogos l--flex">
                                                        {businessCustomers.logo &&
                                                            <GatsbyImage image={getImage(businessCustomers.logo.gatsbyImage)} alt={businessCustomers.logo.altText} />
                                                        }
                                                        {/* <div className="l-customerlogos__mobileOnly">
                                                            {businessCustomers.figureHeader &&
                                                                <h3 dangerouslySetInnerHTML={{ __html: businessCustomers.figureHeader }} />
                                                            }
                                                            {businessCustomers.figureTeaser &&
                                                                <h4 dangerouslySetInnerHTML={{ __html: businessCustomers.figureTeaser }} />
                                                            }
                                                        </div> */}
                                                    </div>
                                                    <div className="l--customerDetails">
                                                        <div>
                                                            {businessCustomers.figureHeader &&
                                                                <h3 dangerouslySetInnerHTML={{ __html: businessCustomers.figureHeader }} />
                                                            }
                                                            {businessCustomers.figureTeaser &&
                                                                <h4 dangerouslySetInnerHTML={{ __html: businessCustomers.figureTeaser }} />
                                                            }
                                                            <p dangerouslySetInnerHTML={{ __html: businessCustomers.content }} />
                                                        </div>
                                                    </div>
                                                    {businessCustomers.link &&
                                                        <span className="l-link"><span>{businessCustomers.link.title}</span> <StaticImage src="../../images/arrow-right-blue-textlink.svg" alt="" /></span>
                                                    }
                                                </a>
                                            }
                                        </>
                                    ))}
                                </Slider>
                                :
                                <>
                                    {data.customerBusinessGridSectionCustomers.map((businessCustomers, index) => (
                                        <React.Fragment key={index}>
                                            {businessCustomers.link &&
                                                <a href={businessCustomers.link.url} target={businessCustomers.link.target} className={`cp-customerBusinessGrid__customers-section l--sliderSection l--${businessCustomers.customerSectionBackgroundColor ? businessCustomers.customerSectionBackgroundColor.substring(1) : ""}`} style={{ backgroundColor: `${businessCustomers.customerSectionBackgroundColor ? businessCustomers.customerSectionBackgroundColor : "#91D8FF"}` }}>
                                                    <div className="l-customerlogos l--flex">
                                                        {businessCustomers.logo &&
                                                            <GatsbyImage image={getImage(businessCustomers.logo.gatsbyImage)} alt={businessCustomers.logo.altText} />
                                                        }
                                                        {/* <div className="l-customerlogos__mobileOnly">
                                                    {businessCustomers.figureHeader &&
                                                        <h3 dangerouslySetInnerHTML={{ __html: businessCustomers.figureHeader }} />
                                                    }
                                                    {businessCustomers.figureTeaser &&
                                                        <h4 dangerouslySetInnerHTML={{ __html: businessCustomers.figureTeaser }} />
                                                    }
                                                </div> */}
                                                    </div>
                                                    <div className="l--customerDetails">
                                                        {businessCustomers.figureHeader &&
                                                            <h3 dangerouslySetInnerHTML={{ __html: businessCustomers.figureHeader }} />
                                                        }
                                                        {businessCustomers.figureTeaser &&
                                                            <h4 dangerouslySetInnerHTML={{ __html: businessCustomers.figureTeaser }} />
                                                        }
                                                        <p dangerouslySetInnerHTML={{ __html: businessCustomers.content }} />
                                                    </div>
                                                    {businessCustomers.link &&
                                                        <span className="l-link"><span>{businessCustomers.link.title}</span> <StaticImage src="../../images/arrow-right-blue-textlink.svg" alt="" /></span>
                                                    }
                                                </a>
                                            }
                                        </React.Fragment>
                                    ))}
                                </>
                            }
                        </>
                    }
                </div>
                {data.customerBusinessGridSectionLogosRepeatePosition === 'no' &&
                    <>
                        {data.customerBusinessGridSectionLogosHeader &&
                            <h3 dangerouslySetInnerHTML={{ __html: data.customerBusinessGridSectionLogosHeader }} />
                        }
                        <div className="cp-customerBusinessGrid__customerLogos l--flex">
                            {data.customerBusinessGridSectionLogosRepeate &&
                                <>
                                    {data.customerBusinessGridSectionLogosRepeate.map((logoRepeater, index) => (
                                        <React.Fragment key={index}>
                                            {logoRepeater.logo &&
                                                <GatsbyImage image={getImage(logoRepeater.logo.gatsbyImage)} alt={logoRepeater.logo.altText} />
                                            }
                                        </React.Fragment>
                                    ))}
                                </>
                            }
                        </div>
                    </>
                }
            </div>
            {data.customerBusinessGridSectionCarouselCheck === 'yes' &&
                <div className="cp-flexibleMastheadGrid__inner l--block l--carousel" >
                    {isRendered &&
                        <Slider {...settings}>
                            {data.genericTwoColumnMastheadSectionWithGridRepeater.map((gridItems, index) => (
                                <React.Fragment key={index}>
                                    <div className="l-gridLogos" key={index}>
                                        {gridItems.logo &&
                                            <img src={gridItems.logo.sourceUrl} alt={gridItems.logo.altText} />
                                        }
                                    </div>
                                </React.Fragment>
                            ))}
                        </Slider>
                    }
                </div>
            }
        </div>
    );
}

export default CustomerBusinessGridSection;